import Modal from '@/components/Modal/';
import { noop } from '@/utils/util';
import React, { Component } from 'react';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import styles from './EditorModal.scss';
import Button from '../../components/Button/Button';

export default class EditorImgModal extends Component {
  static defaultProps = {
    onModalCancelClick: noop,
    onModalConfirmBtnClick: noop,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      isLocal: true,
    };
  }

  onFilesChange = (e) => {
    const { onModalConfirmBtnClick } = this.props;
    // 本地图片
    e.preventDefault();
    e.stopPropagation();
    const tfiles = e.target.files; // tfiles不是一个数组
    const files = [];
    for (let i = 0; i < tfiles.length; i++) {
      files.unshift({ file: tfiles[i] });
    }
    onModalConfirmBtnClick('imgModal', { files }, true);
  };

  onConfirmBtnClick = () => {
    const { onModalConfirmBtnClick, onModalCancelClick } = this.props;
    const url = (this.imgUrlInput.value || '').trim();
    // 网络图片
    if (!url) {
      const error = i18n.get('error.link-no-empty');
      this.setState({
        error,
      });
    } else {
      const files = [{ url }];
      onModalConfirmBtnClick('imgModal', { files }, false);
    }
  };

  togglePanel = (e) => {
    const action = e.target.getAttribute('data-action');
    switch (action) {
      case 'to-url':
        this.setState({
          isLocal: false,
        });
        break;
      case 'to-local':
        this.setState({
          isLocal: true,
        });
        break;
      default:
        break;
    }
  };

  render() {
    const { error, isLocal } = this.state;
    const { onModalCancelClick, visible } = this.props;
    const imgPolicyUrl = 'http://www.jianshu.com/p/c903745c1322';
    return (
      <Modal
        width={412}
        visible
        showFooter={false}
        showMask
        closable
        isMiddle
        onCancel={onModalCancelClick}
      >
        <div className={classNames(styles['kalamu-modal'], styles['kalamu-img-modal'])}>
          <h3>{i18n.get('modal.insertimg')}</h3>
          <div className={classNames(styles['modal-body'])}>
            {
              isLocal &&
              <div className={classNames(styles['tab-panel'])}>
                <div className={styles['upload-picture']}>
                  <label htmlFor="kalamu-upload-image">
                    <i className="fa picture-o"/>
                    {i18n.get('modal.insertimgdes')}
                  </label>
                  <input
                    id="kalamu-upload-image"
                    type="file"
                    name="file"
                    accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                    multiple="multiple"
                    onChange={this.onFilesChange}
                  />
                </div>
                {/* <div
                  className={styles['switch']}
                  onClick={this.togglePanel}
                  data-action='to-url'
                >
                  {i18n.get('modal.chooseurlimg')}
                </div> */}
                <div className={styles['btn-wrap']}>
                  <a
                    href={imgPolicyUrl}
                    rel="noopener noreferrer"
                    target="_blank"
                    className={styles['img-policy']}
                  >
                    <i className="fa fa-question-circle"/>
                    {i18n.get('modal.imgpolicy')}
                  </a>
                  <Button className={styles['btn']} onClick={onModalCancelClick}>
                    {i18n.get('modal.cancel')}
                  </Button>
                </div>
              </div>
            }
            {
              !isLocal &&
              <div className={classNames(styles['tab-panel-url'])}>
                {/* <div className={classNames(styles['input-prepend'])}>
                  <span className={styles['add-on']}>
                    <i className="fa fa-link"/>
                  </span>
                  <input
                    autoFocus
                    id="email"
                    name="email"
                    placeholder={i18n.get('modal.imglinkdes')}
                    type="text"
                    ref={(v) => {
                      this.imgUrlInput = v;
                    }}
                  />
                </div> */}
                <div className={styles['switch']} onClick={this.togglePanel} data-action='to-local'>
                  {i18n.get('modal.choosesysimg')}
                </div>
                <div className={styles['message-text']}>{error}</div>
                <div className={styles['btn-wrap']}>
                  <a
                    href={imgPolicyUrl}
                    rel="noopener noreferrer"
                    target="_blank"
                    className={styles['img-policy']}
                  >
                    <i className="fa fa-question-circle"/>
                    {i18n.get('modal.imgpolicy')}
                  </a>
                  <Button type={'primary'} className={styles['btn']} onClick={this.onConfirmBtnClick}>
                    {i18n.get('modal.confirm')}
                  </Button>
                  <Button className={styles['btn']} onClick={onModalCancelClick}>
                    {i18n.get('modal.cancel')}
                  </Button>
                </div>
              </div>
            }
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditorModal/EditorImgModal.js